<template>
 
  <router-view/>
</template>

<style lang="scss">
*{
  margin: 0;
  padding: 0;
}

html,body,#app{
  
  height: 100%;
}
.relative{
  position: relative;
}
.dialog-container {
  align-items: center;
  flex-direction: column;
  display: flex;
  &.dialog-container-weChat{
    img{
      width: 120px;
      height: 120px;
      margin-top: .5rem;
      margin-bottom: .5rem;
      max-width: 100%;
    }
    p{
      color: rgb(102, 102, 102);
      font-size: 0.75rem;
    }
  }
  &.dialog-container-whatsApp{
    img{
      width: 120px;
      height: 120px;
      margin-top: .5rem;
      margin-bottom: .5rem;
      max-width: 100%;
    }
  
    .text-base{
      font-size: 1rem;
    line-height: 1.5rem;
    }
    .text-xs{
      color: rgb(153,153,153);
      font-size: 0.75rem;
      line-height: 1rem;
    }
  }
}
.absolute {
  width: 0.75rem;
  top: -12px;
  right: -8px;
  position: absolute;
  max-width: 100%;
  display: block;
  vertical-align: middle;
}
</style>

